import React, { ReactElement } from 'react'
import { PortionCount } from '@mindfulchefuk/config/portionCountConfig'
import {
  Flex,
  Icon,
  RadioButton,
  Stack,
  Text,
} from '@mindfulchefuk/design-system'
import { TOnboardingRecipeFilterHandlers } from '../OnboardingRecipeFilterHandlers.types'

type TRecipeFilterPortionCountRadioButtons = {
  onChange: TOnboardingRecipeFilterHandlers['portionCount']
  portionCount: PortionCount
}

export const OnboardingRecipeFilterPortionCountRadioButtons = ({
  portionCount,
  onChange,
}: TRecipeFilterPortionCountRadioButtons): ReactElement => {
  return (
    <Stack spacing={10}>
      <RadioButton
        id="portion-1"
        data-testid="portion-1-radio"
        value={1}
        onChange={(event) =>
          onChange(parseInt(event.target.value, 10) as PortionCount)
        }
        checked={portionCount === 1}
      >
        1 person
      </RadioButton>
      <RadioButton
        id="portion-2"
        data-testid="portion-2-radio"
        value={2}
        onChange={(event) =>
          onChange(parseInt(event.target.value, 10) as PortionCount)
        }
        checked={portionCount === 2}
      >
        2 people
      </RadioButton>
      <RadioButton
        id="portion-4"
        data-testid="portion-4-radio"
        value={4}
        onChange={(event) =>
          onChange(parseInt(event.target.value, 10) as PortionCount)
        }
        checked={portionCount === 4}
      >
        Family
        <Flex position="absolute" left="88px" color="broccoli" top={-10}>
          <Icon type="arrow-curved" position="relative" top={4} mr={4} />
          <Text variant="body-sm">Best value</Text>
        </Flex>
      </RadioButton>
    </Stack>
  )
}
